const ROUTE_PATHS = {
    BADGES: '/badges',
    IN_PROGRESS: '/in-progress',
    REWARDS: '/rewards',
} as const;

export default ROUTE_PATHS;
